/* @ngInject */
export default function footerController() {
  const ctrl = this
  ctrl.$onInit = () => {}
}
